import { SystemStyleObject, chakra } from "@chakra-ui/react";

export const filterBodyWrapperCss: SystemStyleObject = {
  maxHeight: "289px",
  overflow: "hidden scroll",
};

export const FilterBodyItem = chakra("div", {
  base: {},
});

export const filterBodyItemCss: SystemStyleObject = {
  borderBottom: "1px solid #F2F4F7",
  padding: "10px 16px",

  "&:last-child:": {
    borderBottom: "none",
  },
};
